export const ExternalSignInErrorTypes = {
    popupClosed: 'Popup closed by user',
    permissionDenied: 'Access to user data is not allowed',
    error: 'Something went wrong',
    userTriggerNewSigninFlow: 'User triggered new sign-in flow',
};